
define('text!templates/foundation_link.html',[],function () { return 'На форуме включен фонд форума. <a href="/mod/foundation">Помочь форуму</a>.';});

